<template>
  <v-card tile>
    <v-container class="mx-0" style="max-width: 100%;">
      <v-layout row justify-space-between>
        <v-flex xs2>
          <div class="subheading" style="border-right: 1px solid lightgrey">
            <v-icon x-large color="green darken-2">description</v-icon>
            <span class="subheading">类别汇总（万元）</span>
          </div>
        </v-flex>
        <v-flex xs10 class="text-xs-center">
          <table style="width: 100%">
            <tbody>
            <tr>
              <td style="width: 12.5%">{{'纵向'}}</td>
              <td style="width: 12.5%">{{'横向'}}</td>
              <td style="width: 12.5%">{{'国家级'}}</td>
              <td style="width: 12.5%">{{'省部级'}}</td>
              <td style="width: 12.5%">{{'地厅级'}}</td>
              <td style="width: 12.5%">{{'平台'}}</td>
              <td style="width: 12.5%">{{'团队'}}</td>
            </tr>
            <tr>
              <td>{{item[0].zx_amount}}</td>
              <td>{{item[0].hx_amount}}</td>
              <td>{{item[0].gj_amount}}</td>
              <td>{{item[0].sb_amount}}</td>
              <td>{{item[0].dt_amount}}</td>
              <td>{{item[0].pt_amount}}</td>
              <td>{{item[0].td_amount}}</td>
            </tr>
            </tbody>
          </table>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>
<script>
  const uri = '/api/proj/report/teacher-fund-count-by-level-and-index';

  export default {
    props:["startDate","endDate","userId"],
    data() {
      return {
        item: [{
          "all_amount": "",
          "zx_amount": "",
          "hx_amount": "",
          "gj_amount": "",
          "sb_amount": "",
          "dt_amount": "",
          "pt_amount": "",
          "td_amount": ""
        }],
        loading: false,
      }
    },
    watch:{
      "startDate":'get',
      "endDate":'get',
      "userId":'get'
    },
    created() {
      this.get();
    },
    methods:{
      get(){
        if(this.loading || !this.startDate || !this.endDate){
          return
        }
        this.loading = true;
        let params = {"incomeDateStart":this.startDate,"incomeDateEnd":this.endDate,"userId":this.userId};
        this.axios.get(uri, {params: params}).then(
          rsp => {
            this.item = rsp.data;
            this.loading = false;
          })
      }
    }
  }
</script>
<style scoped>

</style>
